import AllostechLogo from './logo/allostech.png';
import styles from './SidebarLogo.module.css';

export const LogoFull = () => (
  <img className={styles.logoFull} src={AllostechLogo} alt="ALLOS" />
);
